module.exports = __webpack_public_path__ + "media/logos/intercom-127cd3ce.png";